import background from './assets/juliusbaer-building.svg';
import { Box } from '@mui/material';

export const MigrationBackground = () => {
  return (
    <>
      <Box
        sx={{
          width: '100%',
          height: '100%',
          position: 'fixed',
          bottom: 0,
          left: 0,
          zIndex: 0,
          backgroundImage: `linear-gradient(180deg, #FFFFFF 33%, #F2F3F9 100%)`,
          backgroundRepeat: 'no-repeat',
        }}
      />
      <Box
        sx={{
          width: '100%',
          height: '100%',
          position: 'fixed',
          bottom: 0,
          left: 0,
          zIndex: 0,
          backgroundImage: `url(${background})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'left 30vw bottom -40px',
          '@media (min-width: 690px)': {
            backgroundPosition: 'right bottom',
          },
        }}
      />
    </>
  );
};
